import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MoveRight } from 'lucide-react';
import SectionHead from '@/components/SectionHead';
import { PATHWAY, PATHWAY_DESTINATIONS } from '@/data/content';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';

export default function Pathway() {
  return (
    <section id="pathway" className="relative py-24 sm:py-32 bg-night-surface border-y border-white/5 overflow-hidden" data-testid="pathway-section">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(230,57,70,0.05),transparent_60%)]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHead
          chapter="06"
          eyebrow="Player Development Pathway"
          title={"YOUR PLAYER'S\nJOURNEY."}
          testId="pathway-heading"
        />

        <motion.div
          variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="relative grid lg:grid-cols-5 gap-4"
          data-testid="pathway-timeline"
        >
          <div className="hidden lg:block absolute top-[52px] left-[10%] right-[10%] h-px bg-gradient-to-r from-brand-red/50 via-brand-gold/50 to-brand-gold" aria-hidden="true" />
          {PATHWAY.map((p, i) => (
            <motion.div key={p.stage} variants={fadeUp} custom={i} className="relative text-center lg:pt-0">
              <div className={`relative z-10 mx-auto w-[104px] h-[104px] rounded-full flex flex-col items-center justify-center border-2 ${
                i === PATHWAY.length - 1
                  ? 'border-brand-gold bg-brand-gold/15 shadow-[0_0_40px_rgba(197,160,89,0.35)]'
                  : 'border-white/15 bg-night'
              }`}>
                <span className="font-display text-[10px] tracking-[0.25em] text-brand-gold">{p.ages.toUpperCase()}</span>
                <span className="font-display text-xl text-white uppercase mt-0.5">{p.stage}</span>
              </div>
              <p className="mt-5 text-sm text-gray-400 leading-relaxed max-w-[26ch] mx-auto">{p.text}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="mt-16 glass-card rounded-sm p-8"
          data-testid="pathway-destinations"
        >
          <div className="text-xs uppercase tracking-[0.3em] text-brand-gold font-semibold">Preparation & Pathways Toward Higher Levels of Competition</div>
          <div className="mt-5 flex flex-wrap gap-3">
            {PATHWAY_DESTINATIONS.map(d => (
              <span key={d} className="flex items-center gap-2 border border-white/10 rounded-full px-4 py-2 text-sm text-gray-300">
                <MoveRight size={14} className="text-brand-red" /> {d}
              </span>
            ))}
          </div>
          <p className="mt-5 text-xs text-gray-500 leading-relaxed">
            ASA focuses on development and preparation. We do not promise college scholarships, professional contracts or placement — we prepare players to earn their opportunities.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
